import api from './api'
import type { AxiosRequestConfig } from 'axios'
import type {
  OrganizationListResponse,
  ProjectListResponse,
  ProjectCreateResponse,
  CreateProjectInput,
  SlugCheckResponse,
  SlugGenerateResponse,
} from '@/schemas/organization'

export const organizationService = {
  async getOrganizations(config?: AxiosRequestConfig): Promise<OrganizationListResponse> {
    const response = await api.get<OrganizationListResponse>('/organizations', config)
    return response.data
  },

  async getProjects(orgId: string, config?: AxiosRequestConfig): Promise<ProjectListResponse> {
    const response = await api.get<ProjectListResponse>(`/organizations/${orgId}/projects`, config)
    return response.data
  },

  async checkSlug(slug: string, config?: AxiosRequestConfig): Promise<SlugCheckResponse> {
    const response = await api.get<SlugCheckResponse>('/organizations/check-slug', {
      params: { slug },
      ...config,
    })
    return response.data
  },

  async generateSlug(name: string, config?: AxiosRequestConfig): Promise<SlugGenerateResponse> {
    const response = await api.get<SlugGenerateResponse>('/organizations/generate-slug', {
      params: { name },
      ...config,
    })
    return response.data
  },

  async createProject(
    orgId: string,
    data: CreateProjectInput,
    config?: AxiosRequestConfig
  ): Promise<ProjectCreateResponse> {
    const response = await api.post<ProjectCreateResponse>(
      `/organizations/${orgId}/projects`,
      data,
      config
    )
    return response.data
  },
}
